module.exports = __webpack_public_path__ + "static/media/conveyor-belt.3b62cb96.svg";